import { render } from "./add_security_context.vue?vue&type=template&id=669cde8f&lang=html"
import script from "./add_security_context.vue?vue&type=script&lang=js"
export * from "./add_security_context.vue?vue&type=script&lang=js"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__